import { AfterViewInit, Component, ElementRef, HostListener, Renderer2 } from '@angular/core';

const MOBILE_BREAKPOINT = 768;

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements AfterViewInit {
  currentyear: number = new Date().getFullYear();

  // Markup hardcodes every footer accordion section to "show" so desktop
  // always displays all four columns. On mobile that means the whole
  // accordion opens fully expanded, then jarringly mass-collapses down to
  // one section the moment a visitor taps any header (they all share
  // data-bs-parent="#footerAccordion"). Collapse everything but the first
  // section up front on mobile so it behaves like an accordion from the start.
  private isMobileLayout: boolean | null = null;

  constructor(private elRef: ElementRef<HTMLElement>, private renderer: Renderer2) {}

  ngAfterViewInit(): void {
    this.updateAccordionLayout();
  }

 @HostListener('window:resize')
onWindowResize(): void {
  this.updateAccordionLayout();
}

  private updateAccordionLayout(): void {
    const isMobile = window.innerWidth < MOBILE_BREAKPOINT;
    if (isMobile === this.isMobileLayout) { return; }
    this.isMobileLayout = isMobile;

    const panels = Array.from(
      this.elRef.nativeElement.querySelectorAll<HTMLElement>('#footerAccordion .accordion-collapse')
    );
    panels.forEach((panel, index) => {
      const button = this.elRef.nativeElement.querySelector<HTMLElement>(`[data-bs-target="#${panel.id}"]`);
      const shouldShow = !isMobile || index === 0;

      if (shouldShow) {
        this.renderer.addClass(panel, 'show');
      } else {
        this.renderer.removeClass(panel, 'show');
      }
      if (button) {
        this.renderer.setAttribute(button, 'aria-expanded', String(shouldShow));
        // Bootstrap's accordion-button chevron rotates off the .collapsed
        // class, not aria-expanded, so it has to be toggled explicitly here.
        if (shouldShow) {
          this.renderer.removeClass(button, 'collapsed');
        } else {
          this.renderer.addClass(button, 'collapsed');
        }
      }
    });
  }
}
